<script setup>
import { computed, toRefs } from 'vue';
import useDataStore from '@/stores/data';

const props = defineProps({
  kakaoProfile: {
    type: String,
    default: '',
  },
});

const {
  getKakaoProfile,
} = useDataStore();

const kakaoProfileData = getKakaoProfile();

const {
  kakaoProfile,
} = toRefs(props);

const profile = computed(() => {
  const { value: id } = kakaoProfile;

  if (!id) {
    return '';
  }

  let profileString = '';
  (kakaoProfileData?.list || []).some(({ label, value }) => {
    if (value === id) {
      profileString = label.replace(/[@]+/, '');
      return true;
    }

    return false;
  });

  return profileString;
});
</script>
<template>
  <span class="advertisement">
    {{ profile }}
  </span>
</template>
